import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { PADB } from 'shared/search/search-service-types';
import { Config } from 'shared/config/env.config';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class SuggestedAttributesService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = PADB;
  idField = 'id';

  getSearchURI(brandId: string, searchModel: SearchModel, itemId: string, partTerminologyId: string, exclude?: Array<number>): string {
    let res = `/part-terminology/attribute-suggestions/${brandId}/${itemId}/${partTerminologyId}`;
    res = `${res}?page=${searchModel.currentPage}&itemsPerPage=${searchModel.itemsPerPage}`;
    if (exclude && exclude.length) {
      res = `${res}&exclude=[${exclude.join(',')}]`;
    }
    return res;
  }

  runSearch(brandId: string, searchModel: SearchModel,
            itemId: string, partTerminologyId: string, exclude?: Array<number>): Observable<any> {
    return this.http.get(`${Config.API}${this.getSearchURI(brandId, searchModel, itemId, partTerminologyId, exclude)}`)

      .pipe(map( (res) => {
        this.updateData(res);
        return res;
      }),
      catchError(this.handleError.bind(this)));
  }
}
